import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Hash links (e.g. Link to="/#how") should scroll to that section, not
    // to the top of the page. Deferred a frame so the destination page has
    // mounted (relevant when the hash link also changes the pathname).
    if (hash) {
      const id = hash.slice(1);
      const scrollToTarget = () => {
        document.getElementById(id)?.scrollIntoView({ block: "start" });
      };
      const raf = requestAnimationFrame(scrollToTarget);
      return () => cancelAnimationFrame(raf);
    }
    // Depend on `search` too, not just `pathname` — clicking a link that only
    // changes the query string (e.g. category filters like
    // /kids-academy?category=kids-coding -> ?category=kids-robotics, or
    // /courses?category=...) previously left the scroll position wherever
    // the user was (e.g. at the footer) instead of resetting to the top.
    //
    // Plain (x, y) form, not the {behavior: "instant"} options object: it's
    // always immediate regardless of any CSS `scroll-behavior: smooth`, has
    // been supported forever, and can't silently no-op the way an options
    // object with an unrecognized/unsupported `behavior` value could.
    // documentElement/body scrollTop are set directly too, belt-and-braces
    // against older/quirky mobile browsers where window.scrollTo alone has
    // been unreliable. See also index.js, which disables the browser's own
    // history scroll-restoration — without that, it can silently override
    // this reset right after it runs.
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, search, hash]);

  return null;
}
